import Vue from "vue";//引入vue
import VueRouter from "vue-router";//引入vue路由

import Home from "@/view/home/index.vue";//首页
Vue.use(VueRouter);//挂在路由插件
const routes = [//路由表示的是url和组件的一一对应的关系，使用path属性表示url路径，使用component属性表示组件
    {
        name:'home',//Home
        path:'/',
        component:Home,
    },
    {
        name:'companyProfile',
        path:'/companyProfile',
        component: () => import('@/view/companyProfile/index.vue'),
    },
    {
        name:'corporateCulture',
        path:'/corporateCulture',
        component: () => import('@/view/corporateCulture/index.vue'),
    },
    {
        name:'history',
        path:'/history',
        component: () => import('@/view/history/index.vue'),
    },
    {
        name:'contactUs',
        path:'/contactUs',
        component: () => import('@/view/contactUs/index.vue'),
    },
    {
        name:'industry',
        path:'/industry',
        component: () => import('@/view/industry/index.vue'),
    },
]
const router = new VueRouter({// 生成一个路由实例
    routes,// 配置项-配置视图和路由之间的对应关系
    mode: 'history'
});
//修改原型对联 的push
// const originalPush = VueRouter.prototype.push;
// VueRouter.prototype.push = function push(location) {
//     return originalPush.call(this, location).catch(err => err)
// }
// //导航守卫
// router.beforeEach((to,from,next)=>{
//     console.log(to,from)
//     next();
// })

export default router // 导出路由实例
